import { PaginatedOrdersResponse } from '@api/orders';
import React from 'react';

interface OrdersContextValue {
    data: PaginatedOrdersResponse | undefined;
    pageNumber: number;
    setPageNumber: (page: number) => void;
}

const OrdersContext = React.createContext<OrdersContextValue | undefined>(undefined);

export { OrdersContext };